import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('pointGroup.index', params);
    },
    create: (context, params) => {
        return apiService.post('pointGroup.index', params);
    },
    update: (context, params) => {
        return apiService.put('pointGroup.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('pointGroup.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
